import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormSearch = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormSearch' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M13.8,13.8 L18,18 L13.8,13.8 Z M10.5,15 C12.9852814,15 15,12.9852814 15,10.5 C15,8.01471863 12.9852814,6 10.5,6 C8.01471863,6 6,8.01471863 6,10.5 C6,12.9852814 8.01471863,15 10.5,15 Z' />
  </StyledIcon>
);
